/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/companylicenses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Licenses redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, February 12, 2024 - 3:42 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/02/12  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyid: 0,
  error: null,
};

const intFields = ["companyid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "companylicenses",
  initialState,
  reducers: {
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
  },
});

export const { updateCompanyID } = sessionSlice.actions;

export default sessionSlice.reducer;
